import React, { useState, useEffect } from "react";
import { Bar } from "react-chartjs-2";
import axios from "axios";
import routes from "../../../app/routes";
import EmptySessionChart from "images/icons/empty_diagram.svg";

export default function Sessions() {
  let [values, setValues] = useState([]);
  let [labels, setLabels] = useState([]);
  let [loader, setLoader] = useState(true);

  const data = {
    labels: labels,
    datasets: [
      {
        label: "Sessions by Statuses",
        data: values,
        backgroundColor: [
          "rgba(33, 150, 83, 1)",
          "rgba(33, 150, 83, 0.75)",
          "rgba(33, 150, 83, 0.5)",
          "rgba(33, 150, 83, 0.25)",
          "rgba(99, 100, 102, 0.75)",
        ],
        borderWidth: 0,
      },
    ],
  };

  const options = {
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        callbacks: {
          title: function (tooltipItem) {
            return ""; //tooltipItem[0].label.replace(",", " ");
          },
          label: function (tooltipItem, data) {
            return (
              tooltipItem.label.replace(",", " ") +
              ": " +
              tooltipItem.formattedValue
            );
          },
        },
      },
    },
    scales: {
      yAxes: [
        {
          ticks: {
            beginAtZero: true,
          },
        },
      ],
    },
  };

  useEffect(() => {
    axios.post(routes.api.coaches.sessions_statistics).then((resp) => {
      let dataValues = Object.values(resp.data);
      let dataKeys = Object.keys(resp.data);
      dataKeys.forEach(function (part, index, theArray) {
        theArray[index] = theArray[index].split("<br/>");
      });
      setValues(dataValues);
      setLabels(dataKeys);
      setLoader(false);
    });
  }, []);

  return (
    <>
      {loader && (
        <div className="wait-loader">
          <i className="fa fa-spinner fa-spin green"></i>
        </div>
      )}
      {!loader && values.reduce((a, b) => a + b, 0) == 0 && (
        <img src={EmptySessionChart} alt="'" />
      )}
      {!loader && values.reduce((a, b) => a + b, 0) > 0 && (
        <Bar height="350px" data={data} options={options} />
      )}
    </>
  );
}
